/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable array-callback-return */
import { Alert, AlertDescription, AlertIcon, AlertTitle, Avatar, Box, Flex, FormControl, Grid, Image, Input, Link, Menu, MenuItem, MenuList, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useToast } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { AxiosResponse } from 'axios'
import * as pdfjsReact from 'pdfjs-dist'
import 'pdfjs-dist/build/pdf.worker.entry'
import { useEffect, useMemo, useState } from 'react'
import { AiFillTool } from 'react-icons/ai'
import { FaCheck, FaClipboard, FaDownload, FaEye, FaEyeSlash, FaFileUpload, FaRegChartBar, FaSave, FaUser } from 'react-icons/fa'
import { MdDownload } from 'react-icons/md'
import { RiBarChartHorizontalFill } from 'react-icons/ri'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../components/InputCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { MenuButtonCmp } from '../../../components/MenuButtonCmp'
import { NavLine } from '../../../components/NavLine'
import { DashBox } from '../../../components/PerfilColaborador/styles'
import { SelectCmp } from '../../../components/SelectCmp'
import { SwitchCmp } from '../../../components/SwitchCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { iColaboradorBase, iCompetencia, iCompetenciaPDI, iEscala, iNomeId, iPerfilPi } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { parseJwt } from '../../../services/token'
import { DownloadImage, HSelect, PropInvalida } from '../../../Utils/Helper'
import { ObterImagemPerfilPI } from '../../../Utils/PerfilPI'
import { Body } from '../../Layouts/Body'
import { SemAcessoResultado } from '../../../components/SemAcessoResultado'
import { iPDI } from '../../PDI/Criar'
import { ModalDataDevolutiva } from '../Resultado/Components/ModalData'
import { BarChart } from './components/BarChart'
import { BoxPDI } from './components/BoxPDI'
import { ChartPercentual } from './components/ChartPercentual'
import { ComparativoChart } from './components/ComparativoChart'
import { ModalPDI } from './components/ModalPDI'
import { PDIChart } from './components/PDIChart'
import { RadarChartJs } from './components/RadarChart'
import { Recomendacao } from './components/Recomendacao'
import { iAcao, TabRecomendacao } from './components/Recomendacoes'
import { RelatorioPDF } from './components/RelatorioPDF'
import PDFRadarChart from './components/RelatorioPDF/Components/RadarChartJs'
import PDFRadarChartComEmote from './components/RelatorioPDF/Components/RadarChartJsComEmote'
import { RelatorioPDFPDL } from './components/RelatorioPDFPDL'
import { Tabela } from './components/Tabela'
import { TabelaPDI } from './components/TabelaPDI'
import { ComentariosContainer, InfoBox, Titulo } from './styles'
const IconeAvaliadores = 'https://sigah.blob.core.windows.net/assets/front/IconeAvaliadores.svg'

export interface iDiscursiva {
  tipoAvaliador: number
  titulo: string
  texto: string
  isDiscursiva: boolean
}

export interface IDadoGrafico {
  medias: number[]
  nome: string
}

export interface IGrafico {
  competencias: string[]
  dados: IDadoGrafico[]
  escala?: iEscala
  definicoesCompetencias?: string[]
}

export interface iComparativoRespostas {
  total: number
  melhor: number
}

export interface iCorTabela {
  eixo: string
  notasPositivas: number[]
  notasNegativas: number[]
  recomendacoes: number[]
}

export interface iLinhaTabela {
  [key: string]: any
  idQuestao: string
  competencia: string
  autoAvaliacao?: string
  gestor?: string
  pares?: string
  outros?: string
  liderados?: string
  consolidado?: string
  altalideranca?: string
  mediaSemAuto: string
  questoes: iLinhaTabela[]
}

export interface iResultadoIndividualResponse {
  pesquisaId: string
  avaliado: iColaboradorBase
  nomePesquisa: string
  totalAvaliadores: number
  totalRespostas: number
  mediaGeral: number
  competencias: iCompetencia[]
  participantes: number[]
  graficoHierarquia?: IGrafico
  graficosEscalasAlternativas?: iGraficosAlternativos[]
  graficosPDI?: IGrafico[]
  graficoInvertido?: IGrafico
  graficoIndividual?: IGrafico
  graficosPercentual?: IDadoGrafico[]
  discursivas: iDiscursiva[]
  recomendacoes: iCompetenciaPDI[]
  tabela: iLinhaTabela[]
  tabelasEscalasAlternativas?: iTabelasEscalasAlternativas[]
  tabelaPDI?: iLinhaTabela[]
  filtro: iNomeId[]
  comparativoId?: string
  pdf?: iPDF
  pdiNormal?: string
  pdiAvaliacao?: string
  liberarResultado: number
  cores: iCorTabela[]
  monitorarDevolutiva: boolean
  entregaDevolutiva: boolean
  dataDevolutiva?: string
  escala: iEscala
  escalaPDI?: iEscala
  boxPDI?: iBoxPDI[]
  is90Graus: boolean
  mudancaEixo: boolean
  adicionarPDI: boolean
  isResponsavel: boolean
  apenasAutoAvaliacao: boolean
  priorizadas: string[]
  acoes?: iAcao[]
  nomeEmpresa: string
  logoEmpresa: string
}

export interface iGraficosAlternativos {
  hierarquia: IGrafico
  individual: IGrafico
}

export interface iTabelasEscalasAlternativas {
  tabela: iLinhaTabela[]
  escala?: iEscala
}

export interface iBoxPDI {
  avatar: string
  competencia: string
  status: number
  statusMensagem: string
  media: string
}

export interface iPDF {
  textoDeConclusao?: string
  competencias: iCompetencia[]
  melhorCompetencia: iCompetencia
  assinaturaGestor: boolean
  assinaturaColaborador: boolean
  mostrarTextoConclusao: boolean
  comentarios: boolean
  introducaoAvaliacao?: boolean
  avaliadoresEscala?: boolean
  recomendacoesIa?: boolean
  identificarAutoavaliacaoComentario?: boolean
}

export interface iResultadoComparativo {
  graficoComparativo?: IGrafico
  graficoComparativoAutoavaliacao?: IGrafico
}

export interface SigmaScores {
  patternNumber?: number
  aSigma: number
  bSigma: number
  cSigma: number
  dSigma: number
  eSigma?: number
  mScore?: number
}

export interface AssessmentResponse {
  selfAssessmentDateTime?: Date
  selfConceptAssessmentDateTime?: Date
  selfSigmaScores: SigmaScores
  selfConceptSigmaScores: SigmaScores
  synthesisSigmaScores: SigmaScores
  totalNumberOfBehavioralAssessments?: number
}
export interface AssessmentReportResponse {
  comportamentos: string
  resumo: string
  estiloGerencia: string
  estiloVenda: string
  estrategiasGerenciamento: string

}

export interface iResponsavelPDL {
  nome: string
  email: string
  numeroEmpresa: string
  numero: string
}

export const ResultadoIndividual: React.FC = () => {
  const toast = useToast()
  const { avaliacaoId } = useParams<{ avaliacaoId: string }>()
  const { pathname } = useLocation()
  const nav = useNavigate()
  const { cid } = parseJwt()
  const [RelatorioComparativo, setRelatorioComparativo] = useState(false)
  const [RelatorioComentarios, setRelatorioComentarios] = useState(true)
  const [ModoEdicao, setModoEdicao] = useState(false)
  const [ModoEdicaoPrioridades, setModoEdicaoPrioridades] = useState(false)
  const [IsLoadingChart, setIsLoadingChart] = useState(false)
  const [IsLoadingCognitivo, setIsLoadingCognitivo] = useState(false)
  const [ComentariosVisiveis, setComentariosVisiveis] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [images, setImages] = useState<Array<{ base64: string, id: string }>>([])
  const [Cognitivo, setCognitivo] = useState<number>()
  const [Combinado, setCombinado] = useState<AssessmentResponse>()
  const [RelatorioPI, setRelatorioPi] = useState<AssessmentReportResponse>()
  const [ImagemPerfilPi, setImagemPerfilPi] = useState<string>()
  const [CarregandoPerfilPi, setCarregandoPerfilPi] = useState(false)
  const [semAcesso, setSemAcesso] = useState(false)

  const [Graficos, setGraficos] = useState<string[]>([])
  const [GraficosEscalasAlternativasHierarquia, setGraficosEscalasAlternativasHierarquia] = useState<Array<{ escala: iEscala, grafico: string }>>([])
  const [GraficosEscalasAlternativasIndividual, setGraficosEscalasAlternativasIndividual] = useState<Array<{ escala: iEscala, grafico: string }>>([])

  const [ModelPDIEditar, setModelPDIEditar] = useState<iPDI>()
  const [Competencias, setCompetencias] = useState<iNomeId[]>([])

  const [ModelRecomendaCoesDoPDI, setModelRecomendaCoesDoPDI] = useState<iAcao[]>([])

  function getRecomendacoesPDI(): void {
    if (Model.pdiAvaliacao) {
      ObterCompetencias()
      appApi.get(`PDI/${Model.pdiAvaliacao}/Editar`)
        .then((res: AxiosResponse<iPDI>) => {
          setModelPDIEditar(res.data)
        })
        .catch(err => console.log(err))
    }
  }

  function ObterAcaoModelo(nome?: string): iAcao | undefined {
    if (PropInvalida(nome)) {
      return undefined
    }
    const alvo = (nome ?? '').trim().toLowerCase()
    return Model.acoes?.find(a => {
      const nomeModelo = a.acao.trim().toLowerCase()
      return nomeModelo === alvo || nomeModelo.startsWith(`${alvo} - `)
    })
  }

  function populaRecomendacoesDoPDI(): void {
    const recomendacoesPDI: iAcao[] = []
    ModelPDIEditar?.acoes.forEach((acao) => {
      const competencia = Competencias.find(c => c.id === acao.competenciaId)
      const nome = competencia?.nome ?? acao.assunto
      const acaoModelo = ObterAcaoModelo(nome)

      recomendacoesPDI.push({
        acao: nome ?? '',
        oqueFazer: PropInvalida(acao.titulo) ? acaoModelo?.oqueFazer ?? '' : acao.titulo ?? '',
        comoFazer: PropInvalida(acao.descricao) ? acaoModelo?.comoFazer ?? '' : acao.descricao ?? '',
        porqueFazer: '',
        icone: acaoModelo?.icone ?? '',
        pergunta: acaoModelo?.pergunta ?? ''
      })
    })

    setModelRecomendaCoesDoPDI(recomendacoesPDI)
  }

  function ObterCompetencias(): void {
    appApi.get('Competencia/Select')
      .then(res => setCompetencias(res.data))
      .catch(err => console.log(err))
  }

  const convertPDFToImages = async (PDFs: Array<{ url: string }>): Promise<void> => {
    try {
      const imageArray: Array<{ base64: string, id: string }> = []
      await PDFs.forEach(async e => {
        const pdf = await pdfjsReact.getDocument(e.url).promise
        const pages = pdf.numPages
        if (pages < 2) {
          toast({
            title: 'Arquivos inválidos: PI - Quadro de desenvolvimento',
            status: 'error',
            duration: 10000,
            position: 'top'
          })
          return
        }

        for (let i = 1; i <= pages; i++) {
          const page = await pdf.getPage(i)
          const scale = 2
          const viewport = page.getViewport({ scale })

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          if (!context) continue

          canvas.width = viewport.width
          canvas.height = viewport.height

          await page.render({ canvasContext: context, viewport }).promise

          // Criar um novo canvas para recorte
          const croppedCanvas = document.createElement('canvas')
          const croppedContext = croppedCanvas.getContext('2d')

          if (!croppedContext) continue

          const cropHeight = viewport.height * 0.725
          const cropWidth = viewport.width * 0.9
          const startX = (viewport.width - cropWidth) / 2
          const startY = (i === 1) ? viewport.height * 0.14 : viewport.height * 0.10

          croppedCanvas.width = cropWidth
          croppedCanvas.height = cropHeight

          croppedContext.drawImage(
            canvas,
            startX, startY, cropWidth, cropHeight,
            0, 0, cropWidth, cropHeight
          )

          const imgData = croppedCanvas.toDataURL('image/png')
          imageArray.push({ base64: imgData, id: `perfilPI${i}` })
        }
      })
    } catch (error) {
      console.error('Erro ao converter PDF:', error)
    }
  }

  function ObterNomeTipoAvaliador(tipo: number): string {
    switch (tipo) {
      case 0:
        return 'Autoavaliação'
      case 1:
        return 'Gestor'
      case 2:
        return 'Par'
      case 3:
        return 'Liderado'
      case 4:
        return 'Outro'
      case 5:
        return 'Gestor'
      case 6:
        return 'Alta liderança'
      default:
        return 'Não indetificado'
    }
  }

  const [Grafico1, setGrafico1] = useState<string>()
  const [Grafico2, setGrafico2] = useState<string>()
  const [Grafico3, setGrafico3] = useState<string>()
  const [Grafico4, setGrafico4] = useState<string>()
  const [GraficoComEmote1, setGraficoComEmote1] = useState<string>()
  const [GraficoComEmote2, setGraficoComEmote2] = useState<string>()
  const [GraficosPDI, setGraficosPDI] = useState<string[]>()
  const [ModelPopuladoPDL, setModelPopuladoPDL] = useState<boolean>(false)
  const [PerfilPi, setPerfilPi] = useState<iPerfilPi>()

  const [Model, setModel] = useState<iResultadoIndividualResponse>({
    graficosPercentual: [],
    pdiAvaliacao: '',
    cores: [],
    is90Graus: false,
    liberarResultado: 1,
    avaliado: {
      id: '',
      nome: ''
    },
    pdf: {
      mostrarTextoConclusao: true,
      melhorCompetencia: {
        discursiva: false,
        doSistema: false,
        icone: '',
        id: '',
        nome: '',
        questoes: []
      },
      competencias: [],
      assinaturaColaborador: false,
      assinaturaGestor: false,
      comentarios: false,
      introducaoAvaliacao: true,
      avaliadoresEscala: true,
      recomendacoesIa: true
    },
    discursivas: [],
    filtro: [],
    mediaGeral: 0,
    nomePesquisa: '',
    participantes: [],
    pesquisaId: '',
    recomendacoes: [],
    tabela: [],
    totalAvaliadores: 0,
    totalRespostas: 0,
    monitorarDevolutiva: false,
    entregaDevolutiva: false,
    escala: {
      id: '',
      fator: 0,
      nome: '',
      respostas: []
    },
    adicionarPDI: false,
    isResponsavel: false,
    priorizadas: [],
    competencias: [],
    mudancaEixo: false,
    apenasAutoAvaliacao: false,
    logoEmpresa: '',
    nomeEmpresa: ''
  })
  const [NotaMinima, setNotaMinima] = useState(0)
  const [NotaMaxima, setNotaMaxima] = useState(0)
  const [NotaMinimaFinal, setNotaMinimaFinal] = useState(0)
  const [NotaMaximaFinal, setNotaMaximaFinal] = useState(0)

  const [Comparativo, setComparativo] = useState<iResultadoComparativo>()

  const [TabGrafico, setTabGrafico] = useState<any>(0)
  const [GraficoComparativoAutoavaliacao, setGraficoComparativoAutoavaliacao] = useState(true)
  const [ModalDataOpen, setModalDataOpen] = useState(false)

  const [ModalPDIsOpen, setModalPDIsOpen] = useState(false)
  const [ComparativoRespostas, setComparativoRespostas] = useState<iComparativoRespostas>()

  const [AtualComparativo, setAtualComparativo] = useState<string>('')

  const [FiltroCompetencia, setFiltroCompetencia] = useState<string>('')
  const [FiltroTipo, setFiltroTipo] = useState<string>('')

  const [IsLoading, SetIsLoading] = useState(false)
  const [IsLoadingComparativo, setIsLoadingComparativo] = useState(false)
  const [IsLoadingIndividual, setIsLoadingIndividual] = useState(false)

  const colors = [
    'var(--Azul)',
    'var(--Green2)',
    'var(--Gray4)',
    'var(--Yellow)',
    'var(--Orange)'
  ]

  function getResultado(): void {
    SetIsLoading(true)
    appApi.get(`AvaliacaoPesquisa/${avaliacaoId as string}/ResultadoIndividual`)
      .then(res => {
        const data = res.data
        setModel(prev => ({
          ...data,
          graficosPercentual: popularGraficoPercentualComGraficoPDI(data),
          graficoInvertido: data.graficoInvertido
            ? {
                ...data.graficoInvertido,
                dados: popularDadosGraficoInvertidoComTabelaPDI(data)
              }
            : null
        }))
        setNotaMaxima(res.data.escala.fator)
        setNotaMaximaFinal(res.data.escala.fator)
        if (!res.data.apenasAutoAvaliacao && (res.data.acoes == null || res.data.acoes === undefined || res.data.acoes.length === 0)) {
          ObterPlanoAcao()
        } else {
          setTimeout(() => {
            SetIsLoading(false)
          }, 3200)
        }
        setPerfilPi(res.data.avaliado.perfilPI)
        setModelPopuladoPDL(true)
      })
      .catch(err => {
        if (err?.response?.status === 403) setSemAcesso(true)
        console.log(err)
      })
  }

  function popularDadosGraficoInvertidoComTabelaPDI(model: iResultadoIndividualResponse): IDadoGrafico[] {
    const base = model.graficoInvertido?.dados ?? []
    const ordem = model.graficoInvertido?.competencias ?? []

    const mapaCampos: Record<string, keyof iLinhaTabela> = {
      Autoavaliação: 'autoAvaliacao',
      Outros: 'outros',
      Liderados: 'liderados',
      Pares: 'pares',
      Gestor: 'gestor',
      'Alta liderança': 'altalideranca',
      Consolidado: 'consolidado'
    }

    const extras = (model.tabelaPDI ?? []).map(g => ({
      nome: g.competencia ?? '',
      medias: ordem.map(nomeCompetencia => {
        const campo = mapaCampos[nomeCompetencia]
        const valor = campo ? g[campo] : undefined

        const numero = Number(String(valor ?? '').replace(',', '.'))
        return Number.isFinite(numero) ? numero : 0
      })
    }))

    return [...base, ...extras]
  }

  function popularGraficoPercentualComGraficoPDI(model: iResultadoIndividualResponse): IDadoGrafico[] {
    const base = model.graficosPercentual ?? []
    const extras = (model.graficosPDI ?? []).map(g => ({
      nome: g.competencias?.[0] ?? '',
      medias: (g.dados ?? []).flatMap(d => d.medias ?? [])
    }))
    return [...base, ...extras]
  }

  function CheckComentariosVisiveis(): void {
    appApi.get('Empresa/Comentarios')
      .then(res => {
        setComentariosVisiveis(res.data)
      })
      .catch(err => console.log(err))
  }

  function ObterPlanoAcao(): void {
    SetIsLoading(true)
    appApi.get(`AvaliacaoPesquisa/${avaliacaoId}/PlanoAcao`)
      .then(res => {
        getResultado()
      })
      .catch(err => {
        console.log(err)
        toast({
          title: 'Não foi possível gerar as recomendações por IA, recarregue a página ou tente novamente mais tarde!',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
      })
      .finally(() => SetIsLoading(false))
  }

  function FiltrarComaparativo(id: string): void {
    setAtualComparativo(id)
    setIsLoadingComparativo(true)
    setComparativo(undefined)
    appApi.get(`AvaliacaoPesquisa/${avaliacaoId as string}/Comparativo/?comparativoId=${id}`)
      .then(res => {
        setComparativo(res.data)
        setIsLoadingComparativo(false)
      })
      .catch(err => { console.log(err); setAtualComparativo(''); setRelatorioComparativo(false); setIsLoadingComparativo(false) })
  }

  function TemColuna(tipo: number): boolean {
    return Model.participantes.includes(tipo)
  }

  function CriarBasePDI(opcao: string, comIA?: boolean): void {
    if (opcao === '1') {
      nav(`/Desempenho/PDI/Criar?responsavelId=${cid === Model.avaliado.id ? Model.avaliado.gestorId ?? cid : cid}&colaboradorId=${Model.avaliado.id}&avaliacaoId=${avaliacaoId ?? ''}${comIA === true ? '&ia=true' : ''}`)
    } else {
      appApi.post(`PDI/${Model.pdiNormal ?? ''}/${comIA === true ? 'IA' : 'Avaliacao'}/${avaliacaoId ?? ''}/Continuar`)
        .then(() => nav(`/Desempenho/PDI/Editar/${Model.pdiNormal ?? ''}`))
        .catch(err => console.log(err))
    }
  }

  function onAlterarDevolutiva(Data: string | null, bool: boolean): void {
    const form = { dataDevolutiva: Data, devolutivaEntregue: bool }
    if (bool && (Data === '' || Data === null)) {
      toast({
        title: 'Preencha o campo de data',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }
    appApi.patch(`AvaliacaoPesquisa/${avaliacaoId ?? ''}/devolutiva`, form)
      .then(() => { setModalDataOpen(false); getResultado() })
      .catch(err => console.log(err))
  }

  function AlterarVisibiliade(visibilidade: boolean): void {
    appApi.patch(`AvaliacaoPesquisa/${avaliacaoId ?? ''}/AlterarVisibilidade?visibilidade=${visibilidade ? 0 : 1}`)
      .then(() => {
        setModel({ ...Model, liberarResultado: Model.liberarResultado === 0 ? 1 : 0 })
      })
      .catch(err => console.log(err))
  }

  function getRespostasMelhoradas(): void {
    let melhor = 0
    let total = Comparativo?.graficoComparativo?.dados[0].medias.length ?? 0
    if (Comparativo?.graficoComparativo) {
      for (let i = 0; i < Comparativo?.graficoComparativo.dados[0].medias.length; i++) {
        if (Comparativo?.graficoComparativo.dados[0].medias[i] < Comparativo?.graficoComparativo.dados[1].medias[i]) {
          melhor += 1
        }
        if (Comparativo?.graficoComparativo.dados[0].medias[i] === -1) {
          melhor = melhor - 1
          total = total - 1
        }
      }
    }
    setComparativoRespostas({ melhor: melhor, total: total ?? 0 })
  }

  function ChangeInputNota(value: string, type: string): void {
    if (type === 'max') {
      if (value === '') {
        setNotaMaxima(GetMaiorMenorNota('>'))
      } else if (!Model.graficoHierarquia?.dados.some(b => b.medias.some(a => a > parseFloat(value)))) {
        setNotaMaxima(parseFloat(value))
      } else {
        toast({
          title: 'Valor de limite máximo deve ser maior que a melhor nota do gráfico!',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
      }
    }
    if (type === 'min') {
      if (value === '') {
        setNotaMinima(0)
      } else if (!Model.graficoHierarquia?.dados.some(b => b.medias.some(a => a < parseFloat(value)))) {
        setNotaMinima(parseFloat(value))
      } else {
        toast({
          title: 'Valor de limite mínimo deve ser menor que a pior nota do gráfico!',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
      }
    }
  }

  function OnChangeGraficoComparativo(): void {
    setIsLoadingComparativo(true)
    setGraficoComparativoAutoavaliacao(!GraficoComparativoAutoavaliacao)
    setTimeout(() => {
      setIsLoadingComparativo(false)
    }, 1500)
  }

  function GetMaiorMenorNota(parameter: string): number {
    const Dados: number[] = []
    Model.graficoHierarquia?.dados.forEach(e => e.medias.forEach(a => Dados.push(a)))
    if (parameter === '>') {
      Dados.sort((a, b) => { return b - a })
      return Dados[0]
    } else {
      Dados.sort((a, b) => { return a - b })
      return Dados[0]
    }
  }

  function SalvarAlteracoes(): void {
    setModoEdicaoPrioridades(false)
    const data = {
      prioridades: Model.priorizadas
    }

    appApi.put(`AvaliacaoPesquisa/${avaliacaoId as string}/Salvar/Campos`, data)
      .then(() => { if (!Model.apenasAutoAvaliacao) { ObterPlanoAcao() } })
      .catch((err) => { console.log(err) })
  }

  function GetInfosPDL(personId: string): void {
    setIsLoadingCognitivo(true)

    appApi.get(`api/PIResultados/txtRelatorio/${personId}`)
      .then((res) => setRelatorioPi(res.data))
      .catch((err) => { console.log(err) })
      .finally(() => console.log('Termino'))

    appApi.get(`api/PIResultados/${personId}`)
      .then((res) => setCognitivo(res.data?.score))
      .catch((err) => { console.log(err) })
      .finally(() => setIsLoadingCognitivo(false))

    appApi.get(`api/PIResultados/combinado?personId=${personId}`)
      .then((res) => setCombinado(res.data))
      .catch((err) => { console.log(err) })
  }

  const responsaveis: iResponsavelPDL[] = [
    {
      nome: 'Nathalia Barra',
      email: 'Nathalia.barra@arquiteturahumana.com.br',
      numero: '11 - 96465-1331',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'Sandro Infantini',
      email: 'sandro.infantini@arquiteturahumana.com.br',
      numero: '11 - 98406-3332',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'Mikaele Araújo',
      email: 'mikaele.araujo@arquiteturahumana.com.br',
      numero: '11 - 99965-3612',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'João Andrade',
      email: 'joao.andrade@arquiteturahumana.com.br',
      numero: '11 - 97141-0189',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'Jefferson Moura',
      email: 'jefferson.moura@arquiteturahumana.com.br',
      numero: '11 - 97144-2814',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'Jéssica Favero',
      email: 'Jessica.favero@arquiteturahumana.com.br',
      numero: '11 - 97406-9578',
      numeroEmpresa: '11 - 2898-0550'
    },
    {
      nome: 'Cleber Catelli',
      email: 'Cleber.catelli@arquiteturahumana.com.br',
      numero: '11 - 99973-9032',
      numeroEmpresa: '11 - 2898-0550'
    }
  ]

  const [Responsavel, setResponsavel] = useState<iResponsavelPDL>(responsaveis[0])

  function ObterMediaCompetencia(questoes: iLinhaTabela[]): number {
    let soma = 0
    questoes.filter(e => !isNaN(parseFloat((e.autoAvaliacao ?? '')))).forEach((e) => {
      soma += parseFloat(e.autoAvaliacao ?? '0')
    })
    return (soma / questoes.filter(e => e.autoAvaliacao).length)
  }

  function handleMedia(): number {
    let mediaAutoAval = 0

    Model.tabela.forEach((e): void => {
      const mediaCompetencia = ObterMediaCompetencia(e.questoes)
      if (!isNaN(mediaCompetencia)) {
        mediaAutoAval += (mediaCompetencia < 0 ? 0 : mediaCompetencia)
      }
    })

    return mediaAutoAval / Model.tabela.filter(e => e.autoAvaliacao).length
  }

  function CalcularMediaGeral(tabela: iLinhaTabela[]): number {
    let mediaAutoAval = 0
    tabela.forEach((e): void => {
      const parse = parseFloat(e.mediaSemAuto.replace(',', '.') ?? '')
      mediaAutoAval = mediaAutoAval + (isNaN(parse) ? 0 : parse)
    })

    return mediaAutoAval / tabela.filter(e => e.autoAvaliacao).length
  }

  function GetGraficosEscalasAlternativas(): any {
    const graficosIndividual: Array<{ escala: iEscala, grafico: string }> = []
    const graficosHierarquia: Array<{ escala: iEscala, grafico: string }> = []
    return Model.graficosEscalasAlternativas?.map((e, i) => {
      return (
        <>
          <PDFRadarChart
            setGrafico={(g) => { if (e.hierarquia.escala) { graficosHierarquia.push({ escala: e.hierarquia.escala, grafico: g }) }; if (Model.graficosEscalasAlternativas && i === (Model.graficosEscalasAlternativas?.length - 1)) { setGraficosEscalasAlternativasHierarquia(graficosHierarquia) } }}
            notaMinimaEscala={0}
            notaMaximaEscala={e.hierarquia.escala?.respostas.some(e => e.peso > 6) ? 10 : e.hierarquia.escala?.respostas.some(e => e.peso > 5) ? 6 : 5}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model?.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={e.hierarquia}
            />
          <PDFRadarChart
            setGrafico={(g) => { if (e.individual.escala) { graficosIndividual.push({ escala: e.individual.escala, grafico: g }) }; if (Model.graficosEscalasAlternativas && i === (Model.graficosEscalasAlternativas?.length - 1)) { setGraficosEscalasAlternativasIndividual(graficosIndividual) } }}
            notaMinimaEscala={0}
            notaMaximaEscala={e.individual.escala?.respostas.some(e => e.peso > 6) ? 10 : e.individual.escala?.respostas.some(e => e.peso > 5) ? 6 : 5}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model?.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={e.individual}
          />
        </>
      )
    })
  }

  function GetGraficosPDIs(): any {
    const graficos: string[] = []
    return Model.graficosPDI?.map((e, i) => {
      return (
        <Flex h={'750px'}>
          <PDIChart
            grafico={e}
            numeroRespostas={Model.totalRespostas}
            id={`pdi-chart-comps-${i}-pdf`}
            getBlob={(g) => { graficos.push(g); if (Model.graficosPDI && i === (Model.graficosPDI?.length - 1)) { setGraficosPDI(graficos) } }}
          />
        </Flex>
      )
    })
  }

  useEffect(() => {
    getResultado()
    CheckComentariosVisiveis()
  }, [])

  useEffect(() => {
    getRespostasMelhoradas()
  }, [Comparativo])

  useEffect(() => {
    if (Model.graficoInvertido) {
      setTabGrafico(2)
    } else if (Model.graficoHierarquia?.dados.length === 2) {
      setTabGrafico(0)
    }

    if (Model.recomendacoes.length !== Model.priorizadas.length) {
      return
    }

    if (!PropInvalida(Model.comparativoId)) {
      FiltrarComaparativo(Model.comparativoId ?? '')
    }

    if (!PropInvalida(Model.escala.respostas[0])) {
      setNotaMinima(0)
      setNotaMinimaFinal(0)
    }

    if (images.length === 0 && Model.avaliado.perfilPI?.urlQuadro) {
      convertPDFToImages([{ url: Model.avaliado.perfilPI.urlQuadro }])
    }
    // console.log(`DADOS: ${Model.avaliado.perfilPI?.personId}`)
    // console.log(`DADOS avaliado: ${Model.avaliado.perfilPI}`)
    // console.log(Model.avaliado)
    // if (Model?.avaliado?.perfilPI?.personId) {
    //   GetInfosPDL(Model?.avaliado?.perfilPI?.personId)
    // }
  }, [Model])

  useEffect(() => {
    setIsLoadingChart(false)
  }, [NotaMaxima, NotaMinima, RelatorioComparativo])

  useEffect(() => {
    setIsLoadingIndividual(true)
    setTimeout(() => {
      setIsLoadingIndividual(false)
    }, 700)
  }, [TabGrafico])

  useEffect(() => {
    if (ModelPopuladoPDL) {
      console.log('dados PI populado')
      // console.log(PerfilPi)
      console.log('dados PI populado')
      GetInfosPDL(PerfilPi?.personId ?? '')
    }
  }, [ModelPopuladoPDL])

  useEffect(() => {
    getRecomendacoesPDI()
  }, [Model.pdiAvaliacao])

  useEffect(() => {
    if (ModelPDIEditar) {
      populaRecomendacoesDoPDI()
    }
  }, [ModelPDIEditar, Competencias, Model.acoes])

  useEffect(() => {
    const url = PerfilPi?.urlResultado
    if (Combinado?.totalNumberOfBehavioralAssessments !== 1 || PropInvalida(url)) return
    setCarregandoPerfilPi(true)
    ObterImagemPerfilPI(url ?? '')
      .then(setImagemPerfilPi)
      .finally(() => setCarregandoPerfilPi(false))
  }, [PerfilPi?.urlResultado, Combinado])

  const PodeBaixarPDL = parseJwt().adm === 'True' && ModelPopuladoPDL && PerfilPi && RelatorioPI && Combinado && !IsLoadingChart && !IsLoadingCognitivo && !CarregandoPerfilPi && (Model.graficoHierarquia ?? (Model.graficosPercentual?.length ?? 0) > 0) && Model.tabela.length > 0

  const ComentariosBloqueadosNoPDL = parseJwt().eid === 'cb763dcf-5271-40ec-9d51-3df58ec9145c'

  const DocumentoRelatorio = useMemo(() => (
    <RelatorioPDF
      comparativo={Model.filtro ? Model.filtro.filter(e => e.id === AtualComparativo)[0] ? Model.filtro.filter(e => e.id === AtualComparativo)[0].nome : '' : ''}
      comparativoRespostas={ComparativoRespostas ?? { melhor: 0, total: 0 }}
      temColuna={TemColuna}
      acoes={ModelRecomendaCoesDoPDI.length > 0 ? ModelRecomendaCoesDoPDI : Model.acoes ? Model.acoes : []}
      Grafico1={Grafico1}
      Grafico2={Grafico2}
      Grafico3={Grafico3}
      Grafico4={Grafico4}
      GraficosPDI={GraficosPDI}
      GraficosPDICompetencias={Model.graficosPDI?.filter(e => e.competencias.length > 0).map(e => { return e.competencias[0] })}
      graficosEscalasAlternativasHierarquia={GraficosEscalasAlternativasHierarquia}
      graficosEscalasAlternativasIndividual={GraficosEscalasAlternativasIndividual}
      graficosPercentual={Graficos}
      comparativoOn={RelatorioComparativo}
      model={Model}
      tipoPesquisa={pathname.includes('AnaliseDesempenho') ? 'Pesquisa de análise e desempenho' : 'Pesquisa de percepção'}
    />
  ), [Model, AtualComparativo, ComparativoRespostas, ModelRecomendaCoesDoPDI, Grafico1, Grafico2, Grafico3, Grafico4, GraficosPDI, GraficosEscalasAlternativasHierarquia, GraficosEscalasAlternativasIndividual, Graficos, RelatorioComparativo, pathname])

  const DocumentoRelatorioPDL = useMemo(() => {
    if (!PerfilPi || !Combinado || !RelatorioPI || !(Model.graficoHierarquia ?? (Model.graficosPercentual?.length ?? 0) > 0)) {
      return null
    }

    return (
      <RelatorioPDFPDL
        avaliado={Model.avaliado}
        classificacaoCognitivo={1}
        comentarios={RelatorioComentarios && !ComentariosBloqueadosNoPDL ? Model.discursivas.map(e => e.texto) : []}
        competencias={Model.competencias}
        eixos={Model.participantes}
        escala={Model.escala}
        grafico1={GraficoComEmote1 ?? ''}
        grafico2={GraficoComEmote2 ?? ''}
        nomeEmpresa={Model.nomeEmpresa}
        logoEmpresa={Model.logoEmpresa}
        tabela={Model.tabela}
        imagensQuadro={images}
        cores={Model.cores}
        graficoHierarquia={Model.graficoHierarquia}
        graficosPercentual={Graficos}
        graficoInvertidoImagem={Grafico4}
        recomendacoes={Model.recomendacoes}
        tipoPesquisa={'percepção'}
        perfilPI={PerfilPi}
        mediaGeral={Model.mediaGeral.toFixed(2)}
        // eslint-disable-next-line no-unneeded-ternary
        acoes={ModelRecomendaCoesDoPDI.length > 0 ? ModelRecomendaCoesDoPDI : Model.acoes ? Model.acoes : []}
        cognitivo={Cognitivo}
        combinado={Combinado}
        responsavel={Responsavel}
        relatorioPi={RelatorioPI}
        imagemPerfilPi={ImagemPerfilPi}
      />
    )
  }, [Model, RelatorioComentarios, ComentariosBloqueadosNoPDL, GraficoComEmote1, GraficoComEmote2, Grafico4, images, Graficos, ModelRecomendaCoesDoPDI, Cognitivo, Combinado, Responsavel, RelatorioPI, PerfilPi, ImagemPerfilPi])

  if (semAcesso) return <SemAcessoResultado />

  return (
    <Body isLoading={IsLoading}>
      <ModalDataDevolutiva
        check={Model.entregaDevolutiva}
        data={Model.dataDevolutiva}
        isOpen={ModalDataOpen}
        onConfirm={(Data, Checkbox) => onAlterarDevolutiva(Data, Checkbox)}
        onRequestClose={() => setModalDataOpen(false)}
      />

      <ModalPDI
        recomendacoes={Model.recomendacoes.length}
        isOpen={ModalPDIsOpen}
        permitirIA
        semPDIAtual={PropInvalida(Model.pdiNormal)}
        onCreate={CriarBasePDI}
        onRequestClose={() => setModalPDIsOpen(false)}
      />

      <Flex opacity={'0'} flexDir='column' position={'absolute'} zIndex={-1} justifyContent={'center'} width={'100%'} maxWidth='1168px'>
        <Flex width={'100%'} flexDir='column'>
          {(Comparativo?.graficoComparativo && GraficoComparativoAutoavaliacao) && (
            <ComparativoChart getBlob={(a) => setGrafico3(a)} fator={Model.escala.fator} grafico={{
              competencias: Comparativo?.graficoComparativo.competencias,
              dados: Comparativo?.graficoComparativo.dados
            }} id='gPDF-1' />
          )}

          {(Comparativo?.graficoComparativoAutoavaliacao && !GraficoComparativoAutoavaliacao) && (
            <ComparativoChart getBlob={(a) => setGrafico3(a)} fator={Model.escala.fator} grafico={{
              competencias: Comparativo?.graficoComparativoAutoavaliacao.competencias,
              dados: Comparativo?.graficoComparativoAutoavaliacao.dados
            }} id='gPDF-0' />
          )}

          {Model.graficosPercentual?.map((e, i) => {
            return (
              <ChartPercentual
                key={i}
                id={`grf-pdf-${i}`}
                grafico={e}
                escala={Model.escala}
                getBlob={(e) => setGraficos(old => [...old, e])}
              />
            )
          })}

          {GetGraficosEscalasAlternativas()}

          {GetGraficosPDIs()}
        </Flex>

        <Flex width={'60%'} flexDir='column'>
          {!IsLoadingChart && Model?.graficoIndividual && Model?.graficoIndividual?.competencias.length > 2 && <PDFRadarChartComEmote
            setGrafico={(e) => setGraficoComEmote1(e)}
            notaMinimaEscala={NotaMinima}
            notaMaximaEscala={NotaMaxima}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model?.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={Model.graficoIndividual}
            cores={Model.cores}
            recomendacoes={Model.recomendacoes}
            tabela={Model.tabela}
          />}

          {!IsLoadingChart && Model?.graficoHierarquia && Model?.graficoHierarquia?.competencias.length > 2 && <PDFRadarChartComEmote
            setGrafico={(e) => setGraficoComEmote2(e)}
            notaMinimaEscala={NotaMinima}
            notaMaximaEscala={NotaMaxima}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={Model.graficoHierarquia}
            cores={Model.cores}
            recomendacoes={Model.recomendacoes}
            tabela={Model.tabela}
          />}

          {!IsLoadingChart && Model?.graficoIndividual && Model?.graficoIndividual?.competencias.length > 2 && <PDFRadarChart
            setGrafico={(e) => setGrafico1(e)}
            notaMinimaEscala={NotaMinima}
            notaMaximaEscala={NotaMaxima}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model?.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={Model.graficoIndividual}
          />}
          {!IsLoadingChart && Model?.graficoIndividual && Model?.graficoIndividual?.competencias.length <= 2 && <BarChart
            id='custom_canvas_background_color_bar_chart_individual_pdf'
            onSetGrafico={(e) => setGrafico1(e)}
            labels={Model?.graficoIndividual?.competencias ?? []}
            series={Model?.graficoIndividual?.dados ?? []}
            notaMinimaEscala={NotaMinimaFinal}
            notaMaximaEscala={NotaMaximaFinal}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
          />}

          {!IsLoadingChart && Model?.graficoHierarquia && Model?.graficoHierarquia?.competencias.length > 2 && <PDFRadarChart
            setGrafico={(e) => setGrafico2(e)}
            notaMinimaEscala={NotaMinima}
            notaMaximaEscala={NotaMaxima}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
            grafico={Model.graficoHierarquia}
          />}
          {!IsLoadingChart && Model?.graficoHierarquia && Model?.graficoHierarquia?.competencias.length <= 2 && <BarChart
            id='custom_canvas_background_color_bar_chart_pdf'
            onSetGrafico={(e) => setGrafico2(e)}
            labels={Model?.graficoHierarquia?.competencias ?? []}
            series={Model?.graficoHierarquia?.dados ?? []}
            notaMinimaEscala={NotaMinimaFinal}
            notaMaximaEscala={NotaMaximaFinal}
            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
          />}

          {!IsLoadingChart && Model.graficoInvertido &&
            <PDFRadarChart
              setGrafico={(e) => setGrafico4(e)}
              notaMinimaEscala={NotaMinima}
              notaMaximaEscala={NotaMaxima}
              stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
              grafico={Model.graficoInvertido}
            />
          }
        </Flex>

      </Flex>

      <Flex margin={'1rem 0'}>
        <NavLine options={[
          {
            nome: 'Gestão de pesquisas',
            path: pathname.includes('Desempenho') ? '/Desempenho/AnaliseDesempenho/Gestao' : '/Jornada/Percepcao/Gestao'
          },
          {
            nome: Model?.nomePesquisa ?? '',
            path: -1
          }, {
            nome: Model?.avaliado?.nome ?? ''
          }
        ]} />
      </Flex>

      <Flex marginBottom={'1rem'} alignItems={'center'} justifyContent={'space-between'} flexFlow='nowrap'>
        <Flex flexDir={'column'}>
          <Flex>
            <Avatar
              marginRight={'.625rem'}
              w={'75px'}
              h={'75px'}
              name={Model?.avaliado.nome}
              src={Model?.avaliado.avatar}
            />
            <Flex flexDir={'column'} justifyContent={'center'}>
              <h4>Avaliado:</h4>
              <Text fontSize={'1.25rem'} fontWeight={'700'} lineHeight={'1.25rem'}>{Model?.avaliado.nome}</Text>
              <h4>Departamento: <strong>{Model?.avaliado?.nomeDepartamento}</strong></h4>
            </Flex>
          </Flex>
        </Flex>
        <Flex gap={'1rem'}>
          {(Model.avaliado.perfilPI) && (
            <DashBox style={{ padding: '0 .5rem', position: 'relative', width: '15rem', height: '6rem', border: '2px solid var(--Azul)', backgroundColor: 'var(--c1)' }}>
              <Flex flexDirection={'column'} gap={'.5rem'}>
                <Flex flexDir='column' width='100%' alignItems={'center'}>
                  {
                    (Model.avaliado.perfilPI?.nomeSelo) && (
                      <Text fontWeight={'500'} fontSize={'12px'}>Perfil comportamental: <Text as={'span'} fontWeight={900}>{Model.avaliado.perfilPI?.nomeSelo}</Text></Text>
                    )
                  }
                  {
                    (Model.avaliado.perfilPI?.urlSelo) && (
                      <Image mt={'.3rem'} width={'2rem'} src={Model.avaliado.perfilPI.urlSelo} />
                    )
                  }
                </Flex>
                <Menu>
                  <MenuButtonCmp small VarColor='Green2'>
                    Baixar Relatorios
                  </MenuButtonCmp>
                  <MenuList bgColor='var(--Azul)'>
                    {
                      (!PropInvalida(Model.avaliado.perfilPI?.urlResultado)) && (
                        <MenuItem bgColor={'var(--c1)'}>
                          <Box as={Link} borderColor='var(--Azul)' p={'.5rem'} fontSize={'13px'} fontWeight={'700'} textDecoration={'none'} color='var(--Azul)' borderRadius={'2rem'} href={Model.avaliado.perfilPI?.urlResultado}
                            _hover={{ boxShadow: '0 3px 12px 1px #00000020', textDecoration: 'none' }}>
                            Perfil comportamental
                          </Box>
                        </MenuItem>
                      )
                    }

                    {
                      (!PropInvalida(Model.avaliado.perfilPI?.urlQuadro)) && (
                        <MenuItem bgColor={'var(--c1)'}>
                          <Box as={Link} borderColor='var(--Azul)' p={'.5rem'} fontSize={'13px'} fontWeight={'700'} textDecoration={'none'} color='var(--Azul)' borderRadius={'2rem'} href={Model.avaliado.perfilPI?.urlQuadro}
                            _hover={{ boxShadow: '0 3px 12px 1px #00000020', textDecoration: 'none' }}>
                            Quadro desenvolvimento pessoal
                          </Box>
                        </MenuItem>
                      )
                    }

                    {
                      (!PropInvalida(Model.avaliado.perfilPI?.urlPlacard)) && (
                        <MenuItem bgColor={'var(--c1)'}>
                          <Box as={Link} borderColor='var(--Azul)' p={'.5rem'} fontSize={'13px'} fontWeight={'700'} textDecoration={'none'} color='var(--Azul)' borderRadius={'2rem'} href={Model.avaliado.perfilPI?.urlPlacard}
                            _hover={{ boxShadow: '0 3px 12px 1px #00000020', textDecoration: 'none' }}>
                            Placard
                          </Box>
                        </MenuItem>
                      )
                    }

                    {
                      (!PropInvalida(Model.avaliado.perfilPI?.urlQuadroGestor)) && (
                        <MenuItem bgColor={'var(--c1)'}>
                          <Box as={Link} borderColor='var(--Azul)' p={'.5rem'} fontSize={'13px'} fontWeight={'700'} textDecoration={'none'} color='var(--Azul)' borderRadius={'2rem'} href={Model.avaliado.perfilPI?.urlQuadroGestor}
                            _hover={{ boxShadow: '0 3px 12px 1px #00000020', textDecoration: 'none' }}>
                            Quadro desenvolvimento gestores
                          </Box>
                        </MenuItem>
                      )
                    }

                  </MenuList>
                </Menu>
              </Flex>
            </DashBox>
          )}
          <InfoBox style={{ flexDirection: 'column', gap: '.125rem 0' }}>
            <span>Média geral</span>
            <h4>{Model.apenasAutoAvaliacao ? handleMedia().toFixed(2) : Model?.mediaGeral.toFixed(2)}</h4>
          </InfoBox>

          <InfoBox>
            <Flex pl={'1rem'}>
              <Image w={'2rem'} h={'2rem'} src={IconeAvaliadores} />
            </Flex>
            <Flex pr={'.75rem'} flexDir={'column'} gap={'.325rem'}>
              <h4>{Model?.totalRespostas}/{Model.totalAvaliadores}</h4>
              <span>Respostas/Total</span>
            </Flex>
          </InfoBox>
        </Flex>
      </Flex>
      {
        (!ModoEdicaoPrioridades && Model.recomendacoes.length > 0) && (
          <>
            <Flex justifyContent={'start'}>
              <h3>Potencial para melhorias</h3>
            </Flex>

            <WhiteContainer margin='.75rem 0'>
              <Grid templateColumns='repeat(2, 1fr)' gap={'1rem'}>
                {
                  Model?.recomendacoes.map((e, i) => {
                    return (
                      <Recomendacao pos={i + 1} recomendacao={e} key={i} />
                    )
                  })
                }
              </Grid>
            </WhiteContainer>
          </>
        )
      }

      {!ModoEdicaoPrioridades &&
        <>
          <Flex gap={'.5rem'} alignItems={'end'}>
          {!IsLoadingChart && Model.tabela.length > 0 && <PDFDownloadLink
            document={DocumentoRelatorio}
            fileName={`Relatorio_Pesquisa_Percepcao_${Model.avaliado.nome.replace(/\s/g, '_')}.pdf`}
          >
            {({ loading }: { loading: boolean }) =>
              (loading || ((PropInvalida(Comparativo) && RelatorioComparativo)))
                ? (
                  <ButtonCmp VarColor='Green2' leftIcon={<FaDownload/>} isLoading>Baixar relatório</ButtonCmp>
                  )
                : <ButtonCmp VarColor='Green2' leftIcon={<FaDownload/>}>Baixar relatório</ButtonCmp>

            }
          </PDFDownloadLink>}
          {(Model.adicionarPDI && (pathname.includes('AnaliseDesempenho') || Model.is90Graus) && PropInvalida(Model.pdiAvaliacao)) && (
            <ButtonCmp
              fontWeight={'500'}
              onClick={() => setModalPDIsOpen(true)}
              leftIcon={<FaClipboard />} VarColor='Green2'
            >Adicionar PDI</ButtonCmp>
          )}

          {((pathname.includes('AnaliseDesempenho') || Model.is90Graus) && !PropInvalida(Model.pdiAvaliacao)) && (
            <ButtonCmp
              fontWeight={'500'}
              onClick={() => nav(`/Desempenho/PDI/Editar/${Model.pdiAvaliacao ?? ''}`)}
              leftIcon={<FaClipboard />} VarColor='Green2'
            >Editar PDI</ButtonCmp>
          )}

          {Model.isResponsavel && (
            <ButtonCmp
              VarColor='Gray3'
              leftIcon={<AiFillTool />}
              onClick={() => setModoEdicaoPrioridades(true)}
            >Modificar competências para melhoria</ButtonCmp>
          )}

          {(Model.liberarResultado === 0 && (parseJwt().adm === 'True' || parseJwt().cid === Model.avaliado.gestorId)) && (
              <ButtonCmp
                borderRadius={'.5rem'}
                VarColor='Rosa'
                leftIcon={<FaEyeSlash />}
                onClick={() => AlterarVisibiliade(false)}
              >Ocultar resultado</ButtonCmp>
          )}

          {(Model.liberarResultado === 1 && (parseJwt().adm === 'True' || parseJwt().cid === Model.avaliado.gestorId)) && (
              <ButtonCmp
                leftIcon={<FaEye />}
                borderRadius={'.5rem'}
                VarColor='Rosa'
                onClick={() => AlterarVisibiliade(true)}
              >Liberar resultado</ButtonCmp>
          )}

        {Model.monitorarDevolutiva &&
          (
            <ButtonCmp VarColor={Model.entregaDevolutiva ? 'Green1' : 'Red'} leftIcon={!Model.entregaDevolutiva ? <FaFileUpload /> : <FaCheck />} onClick={() => setModalDataOpen(true)}>
              <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                <span>Devolutiva</span>
                <small style={{ fontSize: '10px', fontWeight: 400 }}>{Model.entregaDevolutiva ? Model.dataDevolutiva : ''}</small>
              </Box>
            </ButtonCmp>
          )
        }
        {PodeBaixarPDL && DocumentoRelatorioPDL && <Flex gap={'.5rem'} alignItems={'end'}>
            <PDFDownloadLink
              document={DocumentoRelatorioPDL}
              fileName={`Relatorio_PDL_Pesquisa_Percepcao_${Model.avaliado.nome.replace(/\s/g, '_')}.pdf`}
            >
              {({ loading }: { loading: boolean }) =>
                (loading || IsLoading)
                  ? (
                    <ButtonCmp VarColor='Green2' leftIcon={<FaDownload/>} isLoading>Baixar relatório PDL</ButtonCmp>
                    )
                  : <ButtonCmp VarColor='Green2' leftIcon={<FaDownload/>}>Baixar relatório PDL</ButtonCmp>
              }
            </PDFDownloadLink>
            <SelectCmp
              OnChange={(selectedIndex) => {
                if (selectedIndex !== '') {
                  setResponsavel(responsaveis[parseInt(selectedIndex)])
                }
              }}
              title={'Responsável do PDL'}
              value={responsaveis.findIndex(e => e.email === Responsavel.email)?.toString() ?? '0'}
            >
              {responsaveis.map((r, i) => (
                <option key={i} value={i}>
                  {r.nome}
                </option>
              ))}
            </SelectCmp>
            {(ComentariosVisiveis && !ComentariosBloqueadosNoPDL && Model.discursivas.length > 0) && (
              <SelectCmp
                OnChange={(e) => setRelatorioComentarios(e === '1')}
                title={'Incluir comentários'}
                value={RelatorioComentarios ? '1' : '0'}
                w={'9rem'}
              >
                <option value={'0'}>Não</option>
                <option value={'1'}>Sim</option>
              </SelectCmp>
            )}
          </Flex>}
      </Flex>
      <Flex gap={'1rem'} my={'.75rem'}>
        <CheckboxCmp isDisabled={AtualComparativo === ''} isChecked={RelatorioComparativo} OnChange={(e) => { setIsLoadingChart(true); setRelatorioComparativo(e) }}>Incluir comparativo no relatório</CheckboxCmp>
      </Flex>

      <Tabs variant='unstyled'>
        <TabList >
          <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Gráfico {Model.graficosEscalasAlternativas && Model.graficosEscalasAlternativas.length > 0 ? ' da escala padrão' : ''}</Tab>
          {Model.graficosEscalasAlternativas && Model.graficosEscalasAlternativas.length > 0 && <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Demais gráficos</Tab>}
          <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Tabelas</Tab>
          {Model.graficosPercentual && <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Percentual de respostas</Tab>}
          {Model.tabelaPDI && Model.tabelaPDI.length > 0 && Model.graficosPDI && <Tab backgroundColor={'white'} color={'var(--c6)'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>PDI</Tab>}
          <Tab backgroundColor={'white'} color={'var(--c6)'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Comparativo</Tab>
          {(Model?.discursivas) && ComentariosVisiveis && <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Comentários</Tab>}
          {!Model.apenasAutoAvaliacao && <Tab
            backgroundColor={'white'}
            color={'var(--c6)'}
            borderRadius={'0 .25rem 0 0'}
            _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}
          >
          {Model.acoes
            ? 'Recomendações'
            : <Flex alignItems={'center'} gap={'1rem'}>
              Carregando recomendações
              <Spinner size={'sm'}/>
            </Flex>
          }
          </Tab>}
        </TabList>
        <TabPanels background={'white'} boxShadow={'var(--SombraBackground)'} borderBottomLeftRadius='.25rem' borderBottomRightRadius='.25rem'>
          <TabPanel>
            <Flex flexDir={'column'} width={'100%'}>
              {TabGrafico === 0 && Model.graficoHierarquia && (
                <Flex flexDir={'column'} width='100%'>
                  <Flex justifyContent={'space-between'} alignItems={'center'} gap={'.5rem'}>
                    <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'}>
                      <Flex gap={'.75rem'} flex={'1'}>
                        <Titulo>Gráfico de hierarquia</Titulo>
                        {<ElementoTooltipCmp label='Baixar gráfico' bg={'var(--Rosa)'}>
                            <ButtonCmp
                              VarColor='Rosa'
                              small
                              onClick={() => DownloadImage(Grafico2 ?? '')}
                            ><MdDownload size={14} /></ButtonCmp>
                        </ElementoTooltipCmp>}
                      </Flex>
                      {(Model.graficoHierarquia) && (
                        <SwitchCmp value={TabGrafico === 1} OnChange={(e) => { setTabGrafico(1) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                      )}
                    </Flex>
                  </Flex>
                  <LoadingContainer linhas={12} loading={IsLoadingIndividual} my={'1rem'}>
                    <Flex justifyContent={'center'} width='100%' position={'relative'}>
                      <Flex width={Model?.graficoHierarquia.competencias.length > 2 ? '50%' : '100%'} style={Model?.graficoHierarquia.competencias.length > 2 ? {} : { justifyContent: 'center', marginBottom: '1.5rem', marginTop: '.875rem' }}>
                        {Model?.graficoHierarquia.competencias.length > 2 && <RadarChartJs
                          competencias={Model?.graficoHierarquia.competencias ?? []}
                          dados={Model?.graficoHierarquia.dados ?? []}
                          notaMinimaEscala={NotaMinimaFinal}
                          notaMaximaEscala={NotaMaximaFinal}
                          stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                        />}
                        {Model?.graficoHierarquia.competencias.length <= 2 && <BarChart
                          id='custom_canvas_background_color_bar_chart'
                          labels={Model?.graficoHierarquia.competencias ?? []}
                          series={Model?.graficoHierarquia.dados ?? []}
                          notaMinimaEscala={NotaMinimaFinal}
                          notaMaximaEscala={NotaMaximaFinal}
                          stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                        />}
                      </Flex>
                    </Flex>
                    <Box display={'flex'} gap={'.5rem'} justifyContent={'center'} mt={'-1rem'} mb={!ModoEdicao ? '2.5rem' : '2rem'} bg={'transparent'}>
                      <ButtonCmp
                        VarColor='Roxo'
                        onClick={() => setModoEdicao(!ModoEdicao)}
                      >Modo de edição do eixo</ButtonCmp>
                    </Box>
                  </LoadingContainer>
                  {(ModoEdicao) &&
                    <Flex fontSize={'18px'} fontWeight={'600'} flexDirection={'column'} mb={'1rem'} alignItems={'center'} justifyContent={'center'} gap={'1.5rem'}>
                      <Box display={'flex'} fontSize={'.875rem'} justifyContent={'space-between'} alignItems={'center'}><Text as={'span'} minW={'6.5rem'}>Limite mínimo:</Text> <InputCmp max={GetMaiorMenorNota('<')} step={'0.5'} type={'number'} value={NotaMinima} OnChange={(e) => ChangeInputNota(e, 'min')} w={'5rem'} /></Box>
                      <Box display={'flex'} fontSize={'.875rem'} justifyContent={'space-between'} alignItems={'center'}><Text as={'span'} minW={'6.5rem'}>Limite máximo:</Text> <InputCmp min={GetMaiorMenorNota('>')} step={'0.5'} type={'number'} value={NotaMaxima} OnChange={(e) => ChangeInputNota(e, 'max')} w={'5rem'} /></Box>
                      <ButtonCmp VarColor='Green2' onClick={() => {
                        SetIsLoading(true)
                        setIsLoadingChart(true)
                        setNotaMinimaFinal(NotaMinima)
                        setNotaMaximaFinal(NotaMaxima)
                        setTimeout(() => {
                          setIsLoadingChart(false)
                        }, 500)
                        setTimeout(() => {
                          SetIsLoading(false)
                        }, 3000)
                      }}>Salvar</ButtonCmp>
                    </Flex>
                  }
                </Flex>)
              }

              {TabGrafico === 1 && Model.graficoIndividual && (
                <Flex flexDir={'column'} width='100%'>
                  <Flex justifyContent={'space-between'}>
                    <Flex w={'full'} alignItems={'center'} gap={'.5rem'}>
                      <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'} w={'100%'}>
                        <Flex gap={'.75rem'} flex={'1'}>
                          <Titulo>Gráfico individual</Titulo>
                          {<ElementoTooltipCmp label='Baixar gráfico' bg={'var(--Rosa)'}>
                            <ButtonCmp
                              VarColor='Rosa'
                              small
                              onClick={() => DownloadImage(Grafico1 ?? '')}
                            ><MdDownload size={14} /></ButtonCmp>
                          </ElementoTooltipCmp>}
                        </Flex>
                        {(Model.graficoIndividual) && (
                          <SwitchCmp value={TabGrafico === 1} OnChange={(e) => { setTabGrafico(0) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                        )}
                      </Flex>
                    </Flex>
                  </Flex>
                  <LoadingContainer linhas={12} loading={IsLoadingIndividual} my={'1rem'}>
                    <Flex justifyContent={'center'} width='100%' position={'relative'}>
                      <Flex width={Model.graficoIndividual.competencias.length > 2 ? '50%' : '100%'} style={Model.graficoIndividual.competencias.length > 2 ? {} : { justifyContent: 'center', marginBottom: '2.875rem', marginTop: '.875rem' }}>
                          {Model.graficoIndividual.competencias.length > 2 && <RadarChartJs
                            competencias={Model.graficoIndividual.competencias ?? []}
                            dados={Model.graficoIndividual.dados ?? []}
                            notaMinimaEscala={NotaMinima}
                            notaMaximaEscala={NotaMaxima}
                            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala.respostas[1]?.peso ?? 0)) ?? 0}
                          />}
                          {Model.graficoIndividual.competencias.length <= 2 && <BarChart
                            id='custom_canvas_background_color_bar_chart_individual'
                            labels={Model.graficoIndividual.competencias ?? []}
                            series={Model.graficoIndividual.dados ?? []}
                            notaMinimaEscala={NotaMinima}
                            notaMaximaEscala={NotaMaxima}
                            stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala.respostas[1]?.peso ?? 0)) ?? 0}
                          />}
                      </Flex>
                    </Flex>
                    <Box display={'flex'} gap={'.5rem'} justifyContent={'center'} mt={'-3rem'} mb={!ModoEdicao ? '2.5rem' : '2rem'} bg={'transparent'}>
                      <ButtonCmp VarColor='Roxo' onClick={() => setModoEdicao(!ModoEdicao)}>Modo de edição do eixo</ButtonCmp>
                    </Box>
                  </LoadingContainer>
                  {(ModoEdicao) &&
                    <Flex fontSize={'18px'} fontWeight={'600'} flexDirection={'column'} mb={'1rem'} alignItems={'center'} justifyContent={'center'} gap={'1.5rem'}>
                      <Box w={'13.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>Limite mínimo: <Input max={GetMaiorMenorNota('<')} step={'0.5'} type={'number'} value={NotaMinima} onChange={(e) => ChangeInputNota(e.target.value, 'min')} w={'5rem'} /></Box>
                      <Box w={'13.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>Limite máximo: <Input min={GetMaiorMenorNota('>')} step={'0.5'} type={'number'} value={NotaMaxima} onChange={(e) => ChangeInputNota(e.target.value, 'max')} w={'5rem'} /></Box>
                    </Flex>}
                </Flex>)
              }

                {TabGrafico === 2 && Model.graficoInvertido && (
                  <Flex flexDir={'column'} width='100%'>
                    <Titulo>Gráfico de hierarquia</Titulo>
                    <Flex justifyContent={'flex-end'}>
                      <ButtonCmp
                        VarColor='Roxo'
                        onClick={() => setModoEdicao(!ModoEdicao)}
                      >Modo de edição do eixo</ButtonCmp>
                    </Flex>
                    <Flex justifyContent={'center'} width='100%' position={'relative'}>
                      <Flex width={'50%'}>
                        <RadarChartJs
                          competencias={Model?.graficoInvertido.competencias ?? []}
                          dados={Model?.graficoInvertido.dados ?? []}
                          notaMinimaEscala={NotaMinima}
                          notaMaximaEscala={NotaMaxima}
                          stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                        />
                      </Flex>
                    </Flex>
                    {(ModoEdicao) &&
                      <Flex fontSize={'18px'} fontWeight={'600'} flexDirection={'column'} mb={'1rem'} alignItems={'center'} justifyContent={'center'} gap={'1.5rem'}>
                        <Box w={'13.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>Limite mínimo: <Input max={GetMaiorMenorNota('<')} step={'0.5'} type={'number'} value={NotaMinima} onChange={(e) => ChangeInputNota(e.target.value, 'min')} w={'5rem'} /></Box>
                        <Box w={'13.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>Limite máximo: <Input min={GetMaiorMenorNota('>')} step={'0.5'} type={'number'} value={NotaMaxima} onChange={(e) => ChangeInputNota(e.target.value, 'max')} w={'5rem'} /></Box>
                      </Flex>
                    }
                  </Flex>)
                }
              </Flex>
              <Flex flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {Model.escala?.respostas.map((e, i) => {
                  return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
            </TabPanel>
            {Model.graficosEscalasAlternativas && Model.graficosEscalasAlternativas.length > 0 && <TabPanel>
              <Flex flexDir={'column'} gap={'4rem'}>
                {Model.graficosEscalasAlternativas.map(e => {
                  return (
                    <Flex flexDir={'column'} gap='1rem'>
                      <div>
                        <Flex flexDir={'column'} width={'100%'}>
                          <Flex flexDir={'column'} width='100%'>
                            <Flex justifyContent={'space-between'}>
                              <Flex w={'full'} alignItems={'center'} gap={'.5rem'}>
                                <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'} w={'100%'}>
                                  <Flex gap={'.75rem'} flex={'1'}>
                                    <Titulo>Gráfico individual da {e.individual.escala?.nome}</Titulo>
                                    <ElementoTooltipCmp label='Baixar gráfico' bg={'var(--Rosa)'}>
                                      <ButtonCmp
                                        VarColor='Rosa'
                                        small
                                        onClick={() => DownloadImage(GraficosEscalasAlternativasIndividual.find(a => e.individual.escala && (a.escala.id === e.individual.escala.id))?.grafico ?? '')}
                                      ><MdDownload size={14} /></ButtonCmp>
                                    </ElementoTooltipCmp>
                                  </Flex>
                                </Flex>
                              </Flex>
                            </Flex>
                            <LoadingContainer linhas={12} loading={IsLoadingIndividual} my={'1rem'}>
                              <Flex justifyContent={'center'} width='100%' position={'relative'}>
                                <Flex width={'50%'}>
                                  <RadarChartJs
                                    competencias={e.individual.competencias ?? []}
                                    dados={e.individual.dados ?? []}
                                    notaMinimaEscala={0}
                                    notaMaximaEscala={e.individual.escala?.respostas.some(e => e.peso > 6) ? 10 : e.individual.escala?.respostas.some(e => e.peso > 5) ? 6 : 5}
                                    stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala.respostas[1]?.peso ?? 0)) ?? 0}
                                  />
                                </Flex>
                              </Flex>
                          </LoadingContainer>
                          </Flex>
                        </Flex>
                        <Flex flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                          {e.individual.escala?.respostas.map((es, i) => {
                            return (<span key={i}>{es.resposta}{es.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({es.peso})</strong>};</span>)
                          })}
                        </Flex>
                      </div>
                      <div>
                        <Flex flexDir={'column'} width={'100%'}>
                          <Flex flexDir={'column'} width='100%'>
                            <Flex justifyContent={'space-between'}>
                              <Flex w={'full'} alignItems={'center'} gap={'.5rem'}>
                                <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'} w={'100%'}>
                                  <Flex gap={'.75rem'} flex={'1'}>
                                    <Titulo>Gráfico por hierarquia da {e.hierarquia.escala?.nome}</Titulo>
                                    <ElementoTooltipCmp label='Baixar gráfico' bg={'var(--Rosa)'}>
                                      <ButtonCmp
                                        VarColor='Rosa'
                                        small
                                        onClick={() => DownloadImage(GraficosEscalasAlternativasHierarquia.find(a => e.hierarquia.escala && (a.escala.id === e.hierarquia.escala.id))?.grafico ?? '')}
                                      ><MdDownload size={14} /></ButtonCmp>
                                    </ElementoTooltipCmp>
                                  </Flex>
                                </Flex>
                              </Flex>
                            </Flex>
                            <LoadingContainer linhas={12} loading={IsLoadingIndividual} my={'1rem'}>
                              <Flex justifyContent={'center'} width='100%' position={'relative'}>
                                <Flex width={'50%'}>
                                  <RadarChartJs
                                    competencias={e.hierarquia.competencias ?? []}
                                    dados={e.hierarquia.dados ?? []}
                                    notaMinimaEscala={0}
                                    notaMaximaEscala={e.hierarquia.escala?.respostas.some(e => e.peso > 6) ? 10 : e.hierarquia.escala?.respostas.some(e => e.peso > 5) ? 6 : 5}
                                    stepSize={((Model.escala?.respostas[0]?.peso ?? 0) - (Model.escala.respostas[1]?.peso ?? 0)) ?? 0}
                                  />
                                </Flex>
                              </Flex>
                          </LoadingContainer>
                          </Flex>
                        </Flex>
                        <Flex flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                          {e.hierarquia.escala?.respostas.map((es, i) => {
                            return (<span key={i}>{es.resposta}{es.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({es.peso})</strong>};</span>)
                          })}
                        </Flex>
                      </div>
                    </Flex>
                  )
                })}
              </Flex>
              </TabPanel>}

            <TabPanel>
              <Flex flexDir={'column'} gap={'.5rem'}>
                <Titulo>Tabela dos resultados por hierarquia</Titulo>
                <Tabela
                  cores={Model.cores}
                  discursivas={Model.discursivas}
                  linhas={Model.tabela}
                  mediaGeral={Model.mediaGeral}
                  recomendacoes={Model.recomendacoes}
                  temColuna={TemColuna}
                  apenasAutoAvaliacao={Model.apenasAutoAvaliacao}
                />
                <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                  {Model.escala?.respostas.map((e, i) => {
                    return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                  })}
                </Flex>
                <Flex justifyContent={'center'} gap={'1rem'} w={'100%'}>
                  <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                    <Box w={'.65rem'} h={'.65rem'} bgColor={'var(--Orange)'}></Box>
                    Notas mais baixas
                  </Flex>
                  <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                    <Box w={'.65rem'} h={'.65rem'} bgColor={'#00aa00'}></Box>
                    Notas mais altas
                  </Flex>
                </Flex>
              </Flex>
              {Model.tabelasEscalasAlternativas && Model.tabelasEscalasAlternativas.length > 0 && <Flex flexDir={'column'} gap={'2rem'} mt={'1rem'}>
                {Model.tabelasEscalasAlternativas.map(e => {
                  return (<Flex flexDir={'column'} gap='.5rem'>
                    <Titulo>Tabela da {e.escala?.nome}</Titulo>
                    <Tabela
                      cores={[]}
                      discursivas={Model.discursivas}
                      linhas={e.tabela}
                      mediaGeral={CalcularMediaGeral(e.tabela)}
                      recomendacoes={[]}
                      temColuna={TemColuna}
                      apenasAutoAvaliacao={false}
                    />
                    <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                      {e.escala?.respostas.map((e, i) => {
                        return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                      })}
                    </Flex>
                  </Flex>)
                })}
              </Flex>}
            </TabPanel>
            {Model.tabelaPDI && Model.tabelaPDI.length > 0 && Model.graficosPDI && <TabPanel>
              {Model.boxPDI && Model.boxPDI.filter(e => e.status !== 2).length > 0 && <Grid gridTemplateColumns={'repeat(2, 1fr)'} mb={'1.25rem'} gap={'1rem'}>
                  {Model.boxPDI.filter(e => e.status === 0).length > 0 && <BoxPDI model={Model.boxPDI ?? []} status={0}/>}
                  {Model.boxPDI.filter(e => e.status === 1).length > 0 && <BoxPDI model={Model.boxPDI ?? []} status={1}/>}
                </Grid>}
              <Flex flexDir={'column'} gap={'.5rem'}>
                <Flex alignItems={'center'} gap={'.5rem'}>
                  <RiBarChartHorizontalFill color='var(--Azul)' size={22}/>
                  <Titulo>Tabela das competências trabalhadas</Titulo>
                </Flex>
                <TabelaPDI
                  discursivas={Model.discursivas}
                  linhas={Model.tabelaPDI}
                  temColuna={TemColuna}
                />
              </Flex>
              <Flex width={'100%'} margin={'2rem auto 0 auto'} flexDir={'column'} gap={'.5rem'} overflow='hidden'>
                <Flex alignItems={'center'} gap='.5rem' mb={'1rem'}>
                  <FaRegChartBar color='var(--Azul)' size={22}/>
                  <Titulo>Gráficos de respostas por competência trabalhada</Titulo>
                </Flex>
                <Grid gridTemplateColumns={'repeat(2, 1fr)'} flexDir={'column'} gap={'1.5rem'} alignItems={'center'}>
                  {Model.graficosPDI.map((e, i) => {
                    return (
                      <Flex flexDir={'column'} gap={'1.75rem'} p={'1rem'} border={'1px solid var(--c6)'} borderRadius={'.325rem'} height={'26rem'}>
                        <Flex fontSize={'14px'} fontWeight={'700'} justifyContent={'center'}>{e.competencias.length > 0 ? e.competencias[0] : ''}</Flex>
                        <PDIChart
                          grafico={e}
                          numeroRespostas={Model.totalRespostas}
                          id={`pdi-chart-comps-${i}`}
                        />
                      </Flex>
                    )
                  })}
                </Grid>
              </Flex>
              <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {Model.escalaPDI?.respostas.map((e, i) => {
                  return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
            </TabPanel>}
            {Model.graficosPercentual &&
              <TabPanel>
                <Flex flexDir={'column'} width='100%'>
                  <Titulo>Gráfico de percentual</Titulo>
                  <Flex flexWrap={'wrap'} justifyContent={'center'} gap={'1rem'} my='1rem'>
                    {Model.escala.respostas.filter(e => e.peso !== -1).map((e, i) => {
                      return (
                        <Flex key={e.id} gap={'1rem'}>
                          <Box
                            w={'1.625rem'}
                            h={'1.625rem'}
                            bgColor={colors[i]}
                          /> {e.resposta}</Flex>
                      )
                    })}
                  </Flex>
                  <Flex flexDir={'column'} gap='2rem'>
                    {Model.graficosPercentual.map((e, i) => {
                      return (
                        <Flex key={i} justifyContent={'center'} width='100%' position={'relative'}>
                          <Flex width={'80%'}>
                            <ChartPercentual
                              id={`grf-${i}`}
                              grafico={e}
                              escala={Model.escala} />
                          </Flex>
                        </Flex>
                      )
                    })}
                  </Flex>

                  <Flex flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                    {Model.escala?.respostas.map((e, i) => {
                      return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                    })}
                  </Flex>
                </Flex>
              </TabPanel>
            }

          <TabPanel>
              <Flex width={'100%'} flexDir='column' gap={'.5rem'}>
                {
                  (Comparativo?.graficoComparativo) &&
                  <Flex justifyContent={'space-between'}>
                    <Titulo>{GraficoComparativoAutoavaliacao ? 'Gráfico de comparativo das médias sem autoavaliação' : 'Gráfico comparativo - autoavaliacão'}</Titulo>
                      <SwitchCmp value={GraficoComparativoAutoavaliacao} OnChange={(e) => { OnChangeGraficoComparativo() }} legendaDireita={'Sem autoavaliação'} legendaEsquerda={'Apenas autoavaliacão'}/>
                  </Flex>
                }
                  <Flex flexDir={'column'} width='100%'>
                    <FormControl>
                      <SelectCmp title='Pesquisa comparada' value={AtualComparativo} OnChange={FiltrarComaparativo}>
                        <option value={''}>Mais recente</option>
                        {
                          Model?.filtro?.filter(e => e.id !== avaliacaoId).map((e) => {
                            return (
                              <option key={e.id} value={e.id}>{e.nome}</option>
                            )
                          })
                        }
                      </SelectCmp>
                    </FormControl>
                  </Flex>
                <LoadingContainer linhas={12} loading={IsLoadingComparativo}>
                {!Comparativo?.graficoComparativo && (!Model?.filtro?.filter(e => e.id !== avaliacaoId) || Model?.filtro?.filter(e => e.id !== avaliacaoId)?.length === 0) && <Flex alignItems={'center'} justifyContent={'center'} fontWeight='700' py={'7rem'}>
                  Não há resultados anteriores para apresentar o comparativo
                </Flex>}
                {
                  (Comparativo?.graficoComparativo && GraficoComparativoAutoavaliacao) && (
                    <Flex justifyContent={'center'} width='100%'>
                      <Flex width={'100%'}>
                        <ComparativoChart fator={Model.escala.fator} grafico={{
                          competencias: Comparativo?.graficoComparativo.competencias,
                          dados: Comparativo?.graficoComparativo.dados
                        }} id='g-1' />
                      </Flex>
                    </Flex>
                  )
                }
                {
                  (Comparativo?.graficoComparativoAutoavaliacao && !GraficoComparativoAutoavaliacao) && (
                    <Flex justifyContent={'center'} width='100%'>
                      <Flex width={'100%'}>
                        <ComparativoChart fator={Model.escala.fator} grafico={{
                          competencias: Comparativo?.graficoComparativoAutoavaliacao.competencias,
                          dados: Comparativo?.graficoComparativoAutoavaliacao.dados
                        }} id='g-0' />
                      </Flex>
                    </Flex>
                  )
                }
                </LoadingContainer>
              </Flex>
              <Flex flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {Model.escala?.respostas.map(e => {
                  return (<span key={e.id}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
          </TabPanel>

            {(Model?.discursivas && ComentariosVisiveis) && (
              <TabPanel>
                {!Model.discursivas.every(e => PropInvalida(e.tipoAvaliador)) && <Flex gap={'1rem'} marginBottom='1rem' width='50%'>
                  <FormControl>
                    <SelectCmp title='Questões' OnChange={setFiltroCompetencia}>
                      <option value={''}>Todos</option>
                      {
                        HSelect(Model.discursivas, e => e.titulo ?? '', true).map((e, i) => {
                          return (
                            <option value={e} key={i}>{e}</option>
                          )
                        })
                      }
                    </SelectCmp>
                  </FormControl>

                  <FormControl>
                    <SelectCmp title='Tipo do avaliador' OnChange={setFiltroTipo}>
                      <option value={''}>Todos</option>
                      {TemColuna(0) && <option value={'0'}>Autoavaliação</option>}
                      {TemColuna(1) && <option value={'1'}>Gestor</option>}
                      {TemColuna(2) && <option value={'2'}>Par</option>}
                      {TemColuna(3) && <option value={'3'}>Liderado</option>}
                      {TemColuna(6) && <option value={'6'}>Alta liderança</option>}
                      {TemColuna(4) && <option value={'4'}>Outro</option>}
                    </SelectCmp>
                  </FormControl>
                </Flex>}
                {Model.discursivas.length > 0
                  ? <>
                  <h3 style={{ fontSize: '1rem' }}>Comentários: {Model.discursivas.filter((e) => {
                    if (!PropInvalida(e.tipoAvaliador) && FiltroTipo !== '' && (e.tipoAvaliador !== 0 && e.isDiscursiva)) {
                      return null
                    } else if (FiltroCompetencia === '' && FiltroTipo === '') {
                      return e
                    } else if (!PropInvalida(e.tipoAvaliador) && FiltroCompetencia !== '' && FiltroTipo !== '') {
                      if (e.titulo?.includes(FiltroCompetencia) && FiltroTipo === e.tipoAvaliador.toString()) {
                        return e
                      }
                      return null
                    } else if (!PropInvalida(e.tipoAvaliador) && ((FiltroCompetencia !== '' && e.titulo?.includes(FiltroCompetencia)) || (FiltroTipo !== '' && FiltroTipo === e.tipoAvaliador.toString()))) {
                      return e
                    } else if (PropInvalida(e.tipoAvaliador) && FiltroCompetencia === 'Comentários') {
                      return e
                    }
                    return null
                  }).length}</h3>
                <Flex marginTop={'.5rem'} flexDir={'column'} gap='.5rem'>
                  {
                    Model.discursivas.filter((e) => {
                      if (!PropInvalida(e.tipoAvaliador) && FiltroTipo !== '' && (e.tipoAvaliador !== 0 && e.isDiscursiva)) {
                        return null
                      } else if (FiltroCompetencia === '' && FiltroTipo === '') {
                        return e
                      } else if (!PropInvalida(e.tipoAvaliador) && FiltroCompetencia !== '' && FiltroTipo !== '') {
                        if (e.titulo?.includes(FiltroCompetencia) && FiltroTipo === e.tipoAvaliador.toString()) {
                          return e
                        }
                        return null
                      } else if (!PropInvalida(e.tipoAvaliador) && ((FiltroCompetencia !== '' && e.titulo?.includes(FiltroCompetencia)) || (FiltroTipo !== '' && FiltroTipo === e.tipoAvaliador.toString()))) {
                        return e
                      } else if (PropInvalida(e.tipoAvaliador) && FiltroCompetencia === 'Comentários') {
                        return e
                      }
                      return null
                    }).map((e, i) => {
                      return (
                        <ComentariosContainer key={i}>
                          <span>{(!e.isDiscursiva || (e.isDiscursiva && e.tipoAvaliador === 0 && Model.pdf?.identificarAutoavaliacaoComentario !== false)) && `${ObterNomeTipoAvaliador(e.tipoAvaliador)} -`} {e.titulo ?? ''}</span>
                          <strong>{e.texto}</strong>
                          {parseJwt().eid === 'd6856640-fe74-4387-a2ce-f4702ab6c1ab' && <span style={{ fontSize: '10px', fontWeight: 'bold', color: 'var(--c7)' }}
                          ><FaUser /> {ObterNomeTipoAvaliador(e.tipoAvaliador)}</span>}
                        </ComentariosContainer>
                      )
                    })
                  }
                </Flex> </>
                  : <Flex fontWeight={600} fontSize={'14px'}>Não há comentários nesta avaliação, ou você não tem permissão para visualizá-los.</Flex>}
              </TabPanel>
            )}
            {!Model.apenasAutoAvaliacao && <TabPanel px={'2rem'} >
              <TabRecomendacao getIndividual={getResultado} model={Model} onGerarRecomendacoes={ObterPlanoAcao}/>
            </TabPanel>}
          </TabPanels>
        </Tabs>
        </>
      }

      {ModoEdicaoPrioridades &&
        <WhiteContainer>
          <Flex flexDir={'column'} gap={'1.25rem'}>
            <h3 style={{ marginBottom: '.5rem' }}>Potenciais para melhorias</h3>
            <Flex flexDir={'column'} gap='.5rem'>
              <Titulo>Tabela dos resultados por hierarquia</Titulo>
              <Tabela
                cores={Model.cores}
                discursivas={Model.discursivas}
                linhas={Model.tabela}
                recomendacoes={Model.recomendacoes}
                temColuna={TemColuna}
                mediaGeral={Model.mediaGeral}
                priorizadas={Model.priorizadas}
                onPriorizar={(e) => setModel({ ...Model, priorizadas: e })}
                apenasAutoAvaliacao={Model.apenasAutoAvaliacao}
              />
              <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {Model.escala?.respostas.map((e, i) => {
                  return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
            </Flex>

            {Model?.tabelasEscalasAlternativas?.map(e => {
              return (<Flex flexDir={'column'} gap='.5rem'>
              <Titulo>Tabela da {e.escala?.nome}</Titulo>
              <Tabela
                cores={[]}
                discursivas={Model.discursivas}
                linhas={e.tabela}
                mediaGeral={CalcularMediaGeral(e.tabela)}
                recomendacoes={[]}
                temColuna={TemColuna}
                priorizadas={Model.priorizadas}
                onPriorizar={(e) => setModel({ ...Model, priorizadas: e })}
                apenasAutoAvaliacao={false}
              />
              <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {e.escala?.respostas.map((e, i) => {
                  return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
            </Flex>)
            })}
            {Model.tabelaPDI && <Flex flexDir={'column'} gap={'.5rem'}>
              <Flex alignItems={'center'} gap={'.5rem'}>
                <Titulo>Tabela das competências trabalhadas no último PDI do colaborador</Titulo>
              </Flex>
              <TabelaPDI
                discursivas={Model.discursivas}
                linhas={Model.tabelaPDI}
                temColuna={TemColuna}
                priorizadas={Model.priorizadas}
                onPriorizar={(e) => setModel({ ...Model, priorizadas: e })}
              />
              <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                {Model.escalaPDI?.respostas.map((e, i) => {
                  return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                })}
              </Flex>
            </Flex>}
          </Flex>

          <Flex mt={'.75rem'} justifyContent={'end'} gap={'.5rem'}>
            <ButtonCmp VarColor='c6' onClick={() => setModoEdicaoPrioridades(false)}>Voltar</ButtonCmp>
            <ButtonCmp VarColor='Green1' rightIcon={<FaSave />} onClick={SalvarAlteracoes}>Salvar alterações</ButtonCmp>
          </Flex>
        </WhiteContainer>
      }

      {Model.mudancaEixo && <Alert marginTop={'1rem'} borderRadius={'8px'} justifyContent='space-between' status='warning'>
        <Flex flexDir={'column'}>
          <Flex>
            <AlertIcon color={'#FF9900'} />
            <AlertTitle>OBSERVAÇÃO: </AlertTitle>
          </Flex>
          <AlertDescription>Os eixos de Pares, Liderados e Alta Liderança, que não atingiram o mínimo de 3 avaliadores cada, foram agrupados em 'Outros' devido a regra do sistema para evitar rastreamento das respostas.</AlertDescription>
        </Flex>
      </Alert>}
    </Body>
  )
}
